import Vue from 'vue'
import VueRouter from 'vue-router'
import { reqVisitor } from '@/api/home'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'HomeView',
    component: () => import('../views/HomeView/HomeView.vue')
  },
  {
    path: '/tools',
    name: 'Tools',
    component: () => import('../views/Tools/Tools.vue')
  },
  {
    path: '/download',
    name: 'Download',
    component: () => import('../views/Download/Download.vue')
  },
  {
    path: '/submit',
    name: 'Submit',
    component: () => import('../views/Submit/Submit.vue')
  },
  {
    path: '/help',
    name: 'Help',
    component: () => import('../views/Help/Help.vue')
  },
  {
    path: '/network',
    name: 'Network',
    component: () => import('../views/Network/Network.vue')
  },
  {
    path: '/browse',
    name: 'Browse',
    component: () => import('../views/Browse/Browse.vue'),
  },
  {
    path: '/detail',
    name: 'Detail',
    component: () => import('../views/Detail/Detail.vue')
  },
  {
    path: '/modal',
    name: 'Modal',
    component: () => import('../views/Modal/Modal.vue')
  },
  {
    path: '/statistics',
    name: 'Statistics',
    component: () => import('../views/Statistics/Statistics.vue')
  },
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  next();
});
router.afterEach(async(to, from) => {
  const res = await reqVisitor()
  if(res) {
    localStorage.setItem('visitor', res)
  }
});

//push
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

//replace
const VueRouterReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace (to) {
  return VueRouterReplace.call(this, to).catch(err => err)
}
  

export default router
